var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { useDrag } from 'react-use-gesture';
import { animated, useSpring } from '@react-spring/web';
import useMeasure from 'react-use-measure';
import { shadow } from '../theme/shadow';
const StyledSlider = styled.div `
  position: relative;
  height: 12px;
`;
const StyledTracks = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
`;
const StyledTrack = styled(animated.div) `
  position: relative;
  height: 4px;
  border-radius: 6px;
  background-color: ${(props) => props.type === 'prefix' ? 'var(--primary)' : 'var(--bg-color-1)'};
`;
const StyledThumb = styled(animated.div) `
  position: absolute;
  top: 0px;
  left: ${(props) => `${props.left}px`};
  cursor: pointer;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  box-shadow: ${shadow.sm};
  background-color: ${() => '#fff'};
`;
export const Slider = (_a) => {
    var { max = 100, defaultValue = 0 } = _a, props = __rest(_a, ["max", "defaultValue"]);
    const [ref, { width }] = useMeasure();
    const initialX = useRef();
    const [percent, setPercent] = useState(defaultValue / max);
    const controlledPercent = useMemo(() => {
        return props.value ? props.value / max : percent;
    }, [percent]);
    const controlledLeft = useMemo(() => {
        return controlledPercent * width;
    }, [width, controlledPercent]);
    useEffect(() => {
        initialX.current = (defaultValue / max) * width;
    }, [width]);
    const widthStyles = useSpring({
        width: controlledPercent * 100,
    });
    const leftStyles = useSpring({
        left: controlledLeft,
    });
    const bind = useDrag(({ offset: [x] }) => {
        var _a;
        const dragPosition = (x + initialX.current) / width;
        setPercent(dragPosition);
        (_a = props.onSlider) === null || _a === void 0 ? void 0 : _a.call(props, dragPosition);
    });
    return (React.createElement(StyledSlider, Object.assign({ ref: ref }, props),
        React.createElement(StyledTracks, null,
            React.createElement(StyledTrack, { type: "prefix", style: { width: widthStyles.width.to((x) => `${x}%`) } }),
            React.createElement(StyledTrack, { type: "suffix", style: { width: widthStyles.width.to((x) => `${100 - x}%`) } })),
        React.createElement(StyledThumb, Object.assign({}, bind(), { left: controlledLeft, style: { left: leftStyles.left.to((x) => x - 5) } }))));
};
